<template>
    <div class="tabs_content">
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: "ResponsiveTabsContent"
	}
</script>



// WEBPACK FOOTER //
// src/components/common/tabs/TabsContent.vue